// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"az_LP","question":"az_MP"};